/**
 * @generated SignedSource<<9d6869d449e0a690a56c85d5b818f472>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteFilterInput = {
  id?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type deleteFilterMutation$variables = {
  input: DeleteFilterInput;
};
export type deleteFilterMutation$data = {
  readonly deleteFilter: {
    readonly deletedFilterId: string | null;
  } | null;
};
export type deleteFilterMutation = {
  variables: deleteFilterMutation$variables;
  response: deleteFilterMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteFilterPayload",
    "kind": "LinkedField",
    "name": "deleteFilter",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedFilterId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteFilterMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteFilterMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b843bd474120cde047c7a964159fe3e7",
    "id": null,
    "metadata": {},
    "name": "deleteFilterMutation",
    "operationKind": "mutation",
    "text": "mutation deleteFilterMutation(\n  $input: DeleteFilterInput!\n) {\n  deleteFilter(input: $input) {\n    deletedFilterId\n  }\n}\n"
  }
};
})();

(node as any).hash = "861c60cf3ad16435e7fcdf91e29e85e8";

export default node;
